import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { inventoryDestinationList, riskMgmtInternalTicketListAction } from "../../../modules/riskmanagement/action";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";


class ExternalDest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerRows: {
        loadDate: "Load Date",
        ticketNumber: "Ticket Number",
        loadNumber: "Load Number",
        outgoingEstimatedHomeScaleShrinkBushels:
          "Outgoing Estimated Home Scale Shrunk Bushels",
        outgoingFieldEstimatedLoadBushels:
          "Outgoing Field Estimated Load Bushels",
        payloadDelivered: "Reconciled Bushels"
        // balance: "Balance",
        // status: "Status"
      },
      order: "desc",
      orderBy: "id",
      headers: {},
      dataRows: [],
      fetchingComplete: false,
    };
  }

  componentWillMount() {
    const { internalInventoryDest = [], typeId, queryParam, invetoryList} = this.props;
    this.props.inventoryDestinationList(queryParam).then((data)=>{
      if(data) {
        this.createRowData(internalInventoryDest, typeId);

      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.internalInventoryDest &&
      this.props.internalInventoryDest !== nextProps.internalInventoryDest &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true },()=>{
        this.createRowData(nextProps.internalInventoryDest, this.props.typeId);
      });
    } 
    else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }

  }

  createRowData = (internalInventoryDest = [], typeId) => {
    let filteredArr =
      internalInventoryDest &&
      internalInventoryDest.filter(filtered => {
        return filtered.destinationType === typeId;
      });

    let data =
      filteredArr.map(data => {
        let obj = {};
        var date = new Date(data.loadDate);
        obj["loadDate"] = data.loadDate ? moment(date).format("lll") : "NIL";
        obj["ticketNumber"] = data.ticketNumber;
        obj["loadNumber"] = data.loadNumber;
        obj["outgoingEstimatedHomeScaleShrinkBushels"] =
          data.outgoingEstimatedHomeScaleShrinkBushels;
        obj["outgoingFieldEstimatedLoadBushels"] =
          data.outgoingFieldEstimatedLoadBushels;
        obj["payloadDelivered"] = data.payloadDelivered;

        obj["balance"] = data.reconciliation
          ? data.reconciliation.outgoingEstimatedHomeScaleShrinkBushels
            ? parseFloat(
                data.outgoingFieldEstimatedLoadBushels -
                  data.reconciliation.outgoingEstimatedHomeScaleShrinkBushels
              ).toFixed(2)
            : parseFloat(
                data.outgoingFieldEstimatedLoadBushels -
                  data.reconciliation.payloadDelivered
              ).toFixed(2)
          : "";

        obj["status"] = data.status;
        return obj;
      });
    return data;
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { invetoryList, typeId,fetchingComplete } = this.props;
    const { headerRows, order, orderBy, dataRows } = this.state;
    return (
      <div className=" ticket-body">
        {fetchingComplete ?  invetoryList && (
          <CreateTable
            order={order}
            orderBy={orderBy}
            headerRows={headerRows}
            rowData={this.createRowData(invetoryList,typeId)}
            onClick={() => {}}
            onRequestSort={this.handleRequestSort}
            isMenuRequired={false}
            highlightPrimaryColumn={true}
          />
        ): (
          <Loader />
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    invetoryList : state.riskReducer.internalInventoryDest,
    fetchingComplete: state.riskReducer.fetchingComplete
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      inventoryDestinationList,
      riskMgmtInternalTicketListAction
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)  (ExternalDest);



// WEBPACK FOOTER //
// ./src/components/private/RiskManagement/ExternalDest.js